export default {
  subtotal: 'Zwischensumme',
  tip: 'Trinkgeld',
  discount: 'Rabatt',
  method_fee: 'Liefergebühr',
  service_fee: {
    title: 'Servicegebühr',
    description:
      'Diese kleine Servicegebühr hilft uns, die Kosten zu decken, die mit jeder Bestellung verbunden sind – zum Beispiel das Versenden von SMS-Benachrichtigungen zu deiner Bestellung, den Betrieb unserer Online-Bestellplattform und die Abwicklung zusätzlicher transaktionsbezogener Gebühren. Und keine Sorge – diese Gebühr ist immer noch deutlich niedriger als das, was du bei Liefer-Apps zahlen würdest. Danke für dein Verständnis und dafür, dass du uns direkt unterstützt. Wir schätzen das sehr!',
  },
  payment_method_upcharge_fee: {
    title: 'PayPal Gebühr',
    description:
      'Jedes Mal, wenn ein Kunde mit PayPal zahlt, nimmt PayPal 6-7% Gebühren. Also verlieren wir bei 100€ schon 6-7€. Daher müssen wir leider einen Aufschlag von 3,5% für die Nutzung von PayPal erheben. 🤯 Bitte erwäge, eine der anderen sicheren und verschlüsselten Zahlungsmethoden beim Bezahlen zu nutzen. Wir sind sehr dankbar für dein Verständnis und deine Unterstützung! 🙏',
  },
  tax: 'Taxes',
  total: 'Summe',
  earned_points: 'Du hast {{points}} Punkte verdient.',
};
